import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Switch } from 'src/shared/components/form/switch';
import { FrequencyForm } from './frequencyForm/frequencyForm';
export function RecurringSession({ className }) {
    const { t } = useTranslation();
    const { register, watch } = useFormContext();
    const isRecurrent = watch('recurringSession.isRecurrent');
    return (_jsxs("div", { className: clsx('rounded-extralarge border-radius border-small border-neutral-200', className), children: [_jsx(Switch, { className: "m-4", id: "mentorship-is-recurrent", ...register('recurringSession.isRecurrent'), label: t('mentorship.form.recurring_session.label') }), isRecurrent && _jsx(FrequencyForm, {})] }));
}
